export default function InvalidUsageFlag(data, tww_version, cuc) {
  this.tww_version = tww_version;

  this.flag_key = data.flag_key;
  this.flag_description = data.flag_description;
  this.alt_description = data.alt_description;
}
